/**
 * Primeng table data management model
 */
export class PrimeTableDataModel {
  private _pageIndex: number;
  private _results: any[];
  private _totalElements: number;
  private _totalPages: number;

  get pageIndex(): number {
    return this._pageIndex;
  }

  set pageIndex(value: number) {
    this._pageIndex = value;
  }

  get results(): any[] {
    return this._results;
  }

  set results(value: any[]) {
    this._results = value;
  }

  get totalElements(): number {
    return this._totalElements;
  }

  set totalElements(value: number) {
    this._totalElements = value;
  }

  get totalPages(): number {
    return this._totalPages;
  }

  set totalPages(value: number) {
    this._totalPages = value;
  }

  get paginate(): boolean {
    return this._paginate;
  }

  set paginate(value: boolean) {
    this._paginate = value;
  }

  private _paginate: boolean;
}
